import axios from "axios";

export default async function getPassword(access_token, eventId) {
  if (!eventId) return;
  const response = await axios.get(
    `${process.env.REACT_APP_ORGANISER_API}/scan/gen-pass/${eventId}`,
    {
      headers: {
        token: access_token,
      },
    }
  );

  if (!response.data) {
    throw new Error("Some error occurred while generating password");
  }
  if (response.data.error) {
    throw new Error(response.data.error);
  }

  return response.data.password;
}
